import { cn } from '@/utils';
import { ISimulationPlanningCardContentSection } from '@/types';
import { TextHeadline } from '@/components/Text';
import React from 'react';

interface Props {
  section: ISimulationPlanningCardContentSection;
}

/**
 * ContentTitle
 *
 * Renders the title of a content section within a planning card, if it exists.
 * Titles are optional and not all sections will have them.
 */
export const ContentTitle: React.FC<Props> = ({ section }) => {
  const { title } = section ?? {};

  if (!title) {
    return null;
  }

  return (
    <TextHeadline
      align="left"
      className={cn('!font-bold !leading-6')}
      color="neutral-black"
      data-key="section.title"
      level={2}
      text={title}
      variant="bodyLarge"
    />
  );
};
